import React, { useEffect } from "react";

import { Redirect, Route } from "react-router";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { main } from "./routes";
import SideBarNavigation from "../components/complex/SideBarNavigation";
import LoadingIndicator from "../components/simple/LoadingIndicator";

import { checkPermissions } from "../components/permissions";

import Api from "../api";

// eslint-disable-next-line import/prefer-default-export

const PrivateRoute = ({
  component: Component,
  withOutSidebar = false,
  user,
  allow,
  redirectTo,
  ...rest
}) => {
  useEffect(() => {
    if (user.company) return;

    const fetchUserProfile = async () => {
      await Api.user.getUserInfo();
    };

    fetchUserProfile();
  }, [user.company]);

  const permitted =
    user.company && checkPermissions(user.company.currentSubscription, allow);

  if (!user.company) {
    return (
      <div
        style={{
          width: "100vw",
          minHeight: "100vh",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (
          (allow.length && permitted && localStorage.getItem("token")) ||
          (!allow.length && localStorage.getItem("token"))
        ) {
          if (rest.render) {
            return rest.render();
          }
          return (
            <>
              {!withOutSidebar && <SideBarNavigation />}
              <Component {...props} {...rest} />
            </>
          );
        }

        return (
          <Redirect
            to={{
              // pathname: main,
              pathname: redirectTo,
              state: { from: props.location }
            }}
          />
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.any
  ]).isRequired,
  location: PropTypes.shape({}),
  withOutSidebar: PropTypes.bool,
  user: PropTypes.shape({
    company: PropTypes.shape({
      currentSubscription: PropTypes.string
    })
  }).isRequired,
  allow: PropTypes.arrayOf(),
  redirectTo: PropTypes.string
};

PrivateRoute.defaultProps = {
  location: {},
  withOutSidebar: false,
  redirectTo: main,
  allow: []
};

const mapStateToProps = ({ userProfile: { user } }) => ({
  user
});

export default connect(mapStateToProps, null)(PrivateRoute);
